{
  "allWeb3Coins": "सभी Web3 कॉइन",
  "approvalPending": "अनुमोदन जारी है...",
  "assets": "संपत्तियाँ",
  "bnbBalance": "BNB बैलेंस",
  "bnbSendFailed": "BNB भेजने में विफल",
  "bnbSentSuccessfully": "BNB सफलतापूर्वक भेज दिया गया",
  "clearHistory": "हिस्ट्री साफ करें",
  "clearHistoryConfirm": "क्या आप पूरी ट्रांजैक्शन हिस्ट्री हटाना चाहते हैं?",
  "connectWallet": "वॉलेट कनेक्ट करें",
  "connectWalletFirst": "पहले वॉलेट कनेक्ट करें",
  "connectWeb3Wallet": "Web3 वॉलेट कनेक्ट करें",
  "copyAddressReceive": "एड्रेस कॉपी करें / रिसीव करें",
  "disconnect": "डिस्कनेक्ट",
  "enterAmount": "राशि दर्ज करें",
  "fromCoin": "From Coin",
  "history": "History",
  "installWallet": "कृपया MetaMask या Trust Wallet इंस्टॉल करें",
  "insufficientBnbGas": "पर्याप्त BNB नहीं है। गैस फीस के लिए कम से कम 0.01 BNB रखें।",
  "loading": "लोड हो रहा है...",
  "noNewReceiveTransaction": "कोई नया रिसीव ट्रांजैक्शन नहीं मिला",
  "noTransactionsYet": "अभी कोई ट्रांजैक्शन नहीं",
  "processing": "प्रोसेसिंग...",
  "receive": "प्राप्त करें",
  "receiveCrypto": "क्रिप्टो प्राप्त करें",
  "receiveTransactionSynced": "रिसीव ट्रांजैक्शन सिंक हो गया",
  "receiverAddress": "रिसीवर एड्रेस",
  "refreshBalance": "बैलेंस रिफ्रेश करें",
  "searchCoin": "कॉइन खोजें...",
  "searchTransaction": "ट्रांजैक्शन खोजें...",
  "send": "भेजें",
  "sendNow": "अभी भेजें",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "swap": "स्वैप",
  "swapCompleted": "स्वैप पूरा हुआ",
  "swapFailed": "स्वैप विफल",
  "swapNow": "अभी स्वैप करें",
  "swapPending": "स्वैप जारी है...",
  "swapTrade": "स्वैप / ट्रेड",
  "syncHistory": "हिस्ट्री सिंक करें",
  "syncReceive": "रिसीव सिंक करें",
  "toCoin": "To Coin",
  "tokenSwapRouteSoon": "टोकन-से-टोकन स्वैप जल्द जोड़ा जाएगा",
  "totalAssets": "कुल संपत्ति",
  "transactionConfirmed": "ट्रांजैक्शन सफल हुआ",
  "transactionHistory": "ट्रांजैक्शन इतिहास",
  "transactionPending": "ट्रांजैक्शन जारी है...",
  "viewOnBscScan": "BscScan पर देखें",
  "walletAddress": "वॉलेट एड्रेस",
  "walletAddressCopied": "वॉलेट एड्रेस कॉपी हो गया",
  "walletAppNotFound": "MetaMask / Trust Wallet नहीं मिला",
  "walletConnected": "वॉलेट सफलतापूर्वक कनेक्ट हो गया",
  "walletConnectionFailed": "वॉलेट कनेक्ट नहीं हो सका",
  "walletDisconnected": "वॉलेट डिस्कनेक्ट हो गया",
  "walletNotFound": "वॉलेट नहीं मिला",
  "web3Wallet": "एक्साल्ट एक्सचेंज Web3 वॉलेट",
  "web3WalletSubtitle": "सुरक्षित MetaMask / Trust Wallet • BNB Smart Chain • EXALT Wallet"
}